<template>
  <div class="layout-padding">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      :title="album_name"
      desc="등록한 노트들의 현황을 조회할 수 있습니다.">
      <lp-adm-drop-input slot="group_category"
                         :data.sync="cats"
                         :selectVal="selectedGroup"
                         @onSelect="selectCategory"
                         placeholder="팀 선택"
                         width="160px"
                         listAlign="center"
                         style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
    </admin-filter>

    <div class="btn-group-justify-end">
      <button @click="clickReg"
              style="width:120px"
              class="button is-primary">앨범 게시물 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1000"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickModifyDelete(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickModifyDelete(props.item,'delete')">삭제</button>
      </div>

    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import GroupMixin from "@/mixins/GroupMixin"

  export default {
    name: 'AlbumPostList',
    layout:'Main',
    mixins: [
      ListMixin,
      GroupMixin
    ],
    components: {
      LpAdmDropInput

    },
    data () {
      return {
        album_id:1,
        album_name: '',
        cats: [],
        selectedGroup: '',
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('group_album_post', `group/0/album/${this.album_id}/post`);
        this.filtered.group = this.param_group_id;
        if(this.filtered.group !== '') {
          removeIndex(this.filterData,0);
        } else {
          this.getGroupList('cats', true);
        }
        this.getBoardDetail();
      },
      getDataFromServer() {
        this.getData();
      },
      clickReg() {
        let group_id = '';
        if(this.filtered.group)
          group_id = `&group_id=${this.filtered.group}`;
        this.$router.push(`post/create?album_id=${this.album_id}${group_id}`);
      },
      selectCategory(e) {
        if(e.value === '' || e.value === 0) {
          delete this.filtered.group;
          this.selectedGroup = '';
        }

        else {
          this.filtered.group = e.value;
          this.selectedGroup = e.label;
        }

        this.getData();
      },
      getBoardDetail() {
        this.$axios.get(this.getUrl(`group/0/album/${this.album_id}`)).then(res=>{
          this.album_name = res.data.name;
        })
      },
      clickModifyDelete(item, type) {
        if(type === 'update') {
          this.$router.push(this.getPath(`group/album/post/create?
          group_id=${item.group}&album_id=${this.album_id}&post_id=${item.id}`));
        }
        else if(type === 'delete') {
          let value = {
            url: `group/${item.group}/album/${this.album_id}/post/${item.id}`,
            title: '앨범을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'


</style>
